import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/auth-context';
import { useInteractionTracking } from '../hooks/use-visitor-tracking';
import LandingNavbar from '../components/landing/landing-navbar';
import LandingBrandSection from '../components/landing/landing-brand-section';
import LandingFooter from '../components/landing/landing-footer';
import LandingImageCarousel from '../components/landing/landing-image-carousel';
import LandingWelcomeSection from '../components/landing/landing-welcome-section';
import LandingAccommodationSection from '../components/landing/landing-accommodation-section';
import LandingFeaturesSection from '../components/landing/landing-features-section';
import LandingContactSection from '../components/landing/landing-contact-section';

/**
 * Landing Page Component
 * 
 * Main landing page with navbar and footer (no hero section)
 */
export default function LandingPage() {
  const { isAuthenticated, isLoading } = useAuth();
  const navigate = useNavigate();
  const { trackClick } = useInteractionTracking();

  // Track landing page visit
  useEffect(() => {
    trackClick('landing_page_visit', { 
      timestamp: new Date().toISOString(),
      userAgent: navigator.userAgent 
    });
  }, [trackClick]);

  // Only redirect authenticated users, let unauthenticated users see the landing page
  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      // Optionally redirect authenticated users to dashboard
      // Uncomment the line below if you want authenticated users to skip the landing page
      // navigate("/dashboard");
    }
  }, [isAuthenticated, isLoading, navigate]);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: '#d4a574' }}>
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 mx-auto mb-4" style={{ borderColor: '#2C2416' }}></div>
          <p className="text-lg font-medium" style={{ color: '#2C2416' }}>Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col min-h-screen">
      <LandingNavbar />
      <LandingImageCarousel />
      <LandingWelcomeSection />
      <LandingAccommodationSection />
      <LandingFeaturesSection />
      <LandingContactSection />
      <LandingFooter />
    </div>
  );
}
